// extracted by mini-css-extract-plugin
export default {"panel":"CollapsiblePanel_panel__XOG6S","header":"CollapsiblePanel_header__pt7ij","title":"CollapsiblePanel_title__gFOEo","body":"CollapsiblePanel_body__b8Sby"};